import type { CSSProperties } from 'react';
import { cn, initials } from '@/lib/utils';

interface AvatarProps {
  src?: string | null;
  name?: string | null;
  size?: number;
  className?: string;
  /** Extra inline styling (e.g. profile-theme avatar frames). */
  style?: CSSProperties;
}

export function Avatar({ src, name, size = 40, className, style }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name ?? ''}
        className={cn('shrink-0 rounded-full object-cover', className)}
        style={{ width: size, height: size, ...style }}
      />
    );
  }
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full bg-white/10 font-bold text-hi',
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.38, ...style }}
    >
      {initials(name)}
    </div>
  );
}
